export const filters = {
  role: 'Role',
};

export const maxDisplayColumn = 7;

export const systemRole = 'System';
